<template>
  <div class="movies-list-page">
    <!-- 顶部Tab切换 - 固定在顶部 -->
    <div class="tabs-header">
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 0 }"
        @click="switchTab(0)">
        <span class="tab-text">热映</span>
        <div class="tab-line" v-if="activeTab === 0"></div>
      </div>
      <div 
        class="tab-item" 
        :class="{ active: activeTab === 1 }"
        @click="switchTab(1)">
        <span class="tab-text">待映</span>
        <div class="tab-line" v-if="activeTab === 1"></div>
      </div>
    </div>

    <!-- 加载中 -->
    <loading v-if="loading"></loading>

    <!-- 内容区域 - 独立滚动，不影响Tab和导航 -->
    <div v-else class="content-body" ref="scrollContainer" @scroll="handleScroll">
      <!-- 热映列表 -->
      <template v-if="activeTab === 0">
        <div v-if="hotMovies.length > 0" class="list-wrapper">
          <MovieItem :list="hotMovies" />
          <div class="finished-text">没有更多了</div>
        </div>
        <div class="empty-state" v-else>
          <div class="empty-icon">🎬</div>
          <div class="empty-text">当前城市暂无热映影片</div>
        </div>
      </template>

      <!-- 待映列表 -->
      <template v-if="activeTab === 1">
        <div v-if="waitMovies.length > 0" class="list-wrapper">
          <WaitItem :list="waitMovies" :hot-film-ids="hotFilmIds" />
          <div class="finished-text">没有更多了</div>
        </div>
        <div class="empty-state" v-else>
          <div class="empty-icon">🎞️</div>
          <div class="empty-text">当前城市暂无待映影片</div>
        </div>
      </template>
    </div>

    <!-- 返回顶部按钮 -->
    <transition name="fade">
      <div v-show="showBackTop" class="back-top-btn" @click="scrollToTop">
        <van-icon name="arrow-up" size="1.2rem" />
      </div>
    </transition>

    <!-- 底部导航 -->
    <MovieNav />
  </div>
</template>

<script>
import MovieItem from "../../components/movie/MovieItem.vue";
import WaitItem from "../../components/movie/WaitItem.vue";
import MovieNav from "../../components/footnav/MovieNav.vue";

export default {
  name: 'MoviesList',
  components: { MovieItem, WaitItem, MovieNav },
  data() {
    return {
      loading: false,
      activeTab: 0, // 0: 热映, 1: 待映
      hotMovies: [],
      waitMovies: [],
      form: {
        cityCode: ''
      },
      cardId: '',
      filmName: '',
      hotLoaded: false,
      waitLoaded: false,
      showBackTop: false, // 返回顶部按钮显示状态
    }
  },
  methods: {
    switchTab(index) {
      this.activeTab = index;
      // 切换Tab时重置滚动位置
      this.$nextTick(() => {
        if (this.$refs.scrollContainer) {
          this.$refs.scrollContainer.scrollTop = 0;
        }
        this.showBackTop = false;
      });
      // 切换时按需加载数据
      if (index === 0 && !this.hotLoaded) {
        this.queryHotMoviesByCity();
      } else if (index === 1 && !this.waitLoaded) {
        this.queryWaitShowMovie();
      }
    },

    queryHotMoviesByCity() {
      if (!this.cardId) {
        this.cardId = localStorage.getItem("cardId");
      }
      if (!this.form.cityCode) {
        this.form.cityCode = localStorage.getItem("cityCode");
      }
      
      this.loading = true;
      this.$api
        .queryHotMoviesByCity(this.cardId, this.form.cityCode, this.filmName)
        .then((res) => {
          this.loading = false;
          this.hotLoaded = true;
          if (res.code == 1) {
            return;
          }
          this.hotMovies = res.data || [];
        })
        .catch((err) => {
          this.loading = false;
          this.hotLoaded = true;
          console.error('查询热映失败:', err);
          this.$Toast(err.msg || '查询失败');
        });
    },

    queryWaitShowMovie() {
      this.loading = true;
      this.$api
        .queryWaitShowMovie()
        .then((res) => {
          this.loading = false;
          this.waitLoaded = true;
          if (res.code == 1) {
            this.$Toast(res.msg);
            return;
          }
          this.waitMovies = res.data || [];
        })
        .catch((err) => {
          this.loading = false;
          this.waitLoaded = true;
          console.error('查询待映失败:', err);
          this.$Toast(err.msg || '查询失败');
        });
    },

    // 滚动事件处理
    handleScroll(e) {
      const scrollTop = e.target.scrollTop;
      this.showBackTop = scrollTop > 300;
    },

    // 返回顶部
    scrollToTop() {
      const container = this.$refs.scrollContainer;
      if (container) {
        container.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
      }
    },
  },
  mounted() {
    // 初始化由 beforeRouteEnter 处理
  },
  computed: {
    // 热映影片ID列表，用于判断待映影片是否可购票
    hotFilmIds() {
      return this.hotMovies.map(item => item.filmId);
    }
  },
  beforeRouteEnter(to, from, next) {
    next(vm => {
      vm.cardId = localStorage.getItem("cardId");
      vm.filmName = to.query.filmName || '';
      vm.form.cityCode = localStorage.getItem("cityCode");
      vm.hotLoaded = false;
      vm.waitLoaded = false;
      vm.queryHotMoviesByCity();
    });
  }
}
</script>

<style lang="scss" scoped>
.movies-list-page {
  height: 100vh;
  background: #f5f5f5;
  display: flex;
  flex-direction: column;
  overflow: hidden; /* 防止整体页面滚动 */
}

/* 顶部Tab - 固定不滚动 */
.tabs-header {
  flex-shrink: 0;
  display: flex;
  background: #fff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  z-index: 10;
}

.tab-item {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0.9rem 0 0.6rem;
  cursor: pointer;
  position: relative;
  transition: all 0.2s ease;
  
  &.active {
    .tab-text {
      color: #ee0a24;
      font-weight: 600;
    }
  }
  
  &:active {
    background: #f9f9f9;
  }
}

.tab-text {
  font-size: 1rem;
  color: #666;
  font-weight: 500;
  transition: all 0.2s ease;
}

.tab-line {
  width: 1.5rem;
  height: 3px;
  background: linear-gradient(135deg, #ee0a24 0%, #ff6b4a 100%);
  border-radius: 2px;
  margin-top: 0.4rem;
}

/* 内容区域 - 独立滚动 */
.content-body {
  flex: 1;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  padding: 0.8rem;
  padding-bottom: 5rem; /* 留出底部导航高度 */
}

.list-wrapper {
  min-height: 100%;
}

/* 底部提示 */
.finished-text {
  text-align: center;
  padding: 1rem;
  color: #969799;
  font-size: 0.85rem;
}

/* 空状态 */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5rem 1rem;
  text-align: center;
  
  .empty-icon {
    font-size: 3.5rem;
    margin-bottom: 1.2rem;
    opacity: 0.5;
  }
  
  .empty-text {
    color: #999;
    font-size: 1.1rem;
    font-weight: 500;
  }
}

/* 返回顶部按钮 - 提高z-index确保不被遮挡 */
.back-top-btn {
  position: fixed;
  right: 1rem;
  bottom: 6rem;
  width: 2.8rem;
  height: 2.8rem;
  background: linear-gradient(135deg, #ee0a24 0%, #ff6b4a 100%);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #fff;
  box-shadow: 0 4px 12px rgba(238, 10, 36, 0.3);
  z-index: 999; /* 提高层级确保显示 */
  cursor: pointer;
  
  &:active {
    transform: scale(0.95);
  }
}

/* 淡入淡出动画 */
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>